import React, { useState } from 'react'
import { formatAsCurrency } from '../index'
import isEmpty from 'lodash/isEmpty'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes'

const ProductListRow = ({ line, idx, orderData, includeTax, onRemoveProduct, onUpdateProduct }) => {
    const [localQuantity, setLocalQuantity] = useState(
        line.quantity || line.multipleOfSaleQuantity || 1
    )

    const storefrontUrl =
        process.env.REACT_APP_STOREFRONT_URL || 'http://carbon-staging.peracto3.pub'

    const variantQueryString = variantOptions => {
        if (!variantOptions || isEmpty(variantOptions)) {
            return ''
        } else {
            let q = '?'

            for (const [code, values] of Object.entries(variantOptions)) {
                q += `${code}=${values.identifier}&`
            }

            return q
        }
    }

    return (
        <tr>
            <td>
                <img src={line.item?.image} className="!w-full" />
            </td>
            <td className="overflow-anywhere">
                <a
                    className="text-black"
                    href={`${storefrontUrl}/products/${line.item.slug}${variantQueryString(
                        line?.item?.variantOptions
                    )}`}
                    target="_blank"
                    rel="noreferrer"
                >
                    <p className="!font-bold !mb-0">{line.item?.name}</p>
                </a>

                <p className="text-grey text-small !mb-0">{line.item?.sku}</p>

                {!isEmpty(line.item?.variantOptions) && (
                    <p className="!mb-2 text-small">
                        {Object.values(line.item.variantOptions).map(v => (
                            <>
                                <span className="!font-bold">{v.name}:</span> {v.displayValue}{' '}
                            </>
                        ))}
                    </p>
                )}
            </td>
            <td className="!text-right">
                <input
                    type="number"
                    className="form-control form-control-sm"
                    placeholder="Product Quantity"
                    onChange={e => {
                        if (parseInt(e.target.value) > 0) {
                            setLocalQuantity(parseInt(e.target.value))
                        } else {
                            setLocalQuantity(null)
                        }
                    }}
                    onBlur={() => {
                        if (!localQuantity) {
                            setLocalQuantity(
                                line?.minimumOrderQuantity || line?.multipleOfSaleQuantity || 1
                            )
                        }
                        if (
                            line?.multipleOfSaleQuantity &&
                            localQuantity % line.multipleOfSaleQuantity !== 0
                        ) {
                            const remainder = localQuantity % line.multipleOfSaleQuantity
                            setLocalQuantity(
                                localQuantity - remainder || line.multipleOfSaleQuantity
                            )
                        }
                    }}
                    min={
                        line.multipleOfSaleQuantity && line.multipleOfSaleQuantity > 1
                            ? line.multipleOfSaleQuantity
                            : 1
                    }
                    step={line.multipleOfSaleQuantity ? line.multipleOfSaleQuantity : 1}
                    value={localQuantity}
                />

                <button
                    className="btn btn-link text-small !w-full"
                    onClick={() => {
                        onUpdateProduct({ ...line, quantity: localQuantity }, idx)
                    }}
                    disabled={Number(line.quantity) === Number(localQuantity)}
                >
                    Update
                </button>
            </td>

            <td className="!text-right">
                {formatAsCurrency(
                    includeTax ? line?.linePrice?.incTax : line?.linePrice?.excTax,
                    orderData?.currency
                )}

                {line?.promotions?.length > 0 &&
                    line.promotions.map((promo, idx) => (
                        <p
                            key={`basket_promo_${idx}`}
                            className="!text-right text-small text-grey !mb-0"
                            title={promo.promotion.name}
                        >
                            -
                            {formatAsCurrency(
                                includeTax ? promo.discount?.incTax : promo.discount?.excTax,
                                orderData?.currency
                            )}
                        </p>
                    ))}
            </td>

            <td className="!text-right">
                <button
                    className="btn btn-sm btn-outline-danger"
                    onClick={() => onRemoveProduct(line)}
                >
                    <FontAwesomeIcon icon={faTimes} />
                </button>
            </td>
        </tr>
    )
}

export const ProductList = props => {
    return (
        <table className="table">
            <colgroup>
                <col width="10%" />
                <col width="40%" />
                <col width="15%" />
                <col width="15%" />
                <col width="15%" />
            </colgroup>

            <thead>
                <tr>
                    <th className="!border-t-0"></th>
                    <th className="!border-t-0">Product</th>
                    <th className="!border-t-0 !text-right">Quantity</th>
                    <th className="!border-t-0 !text-right">Total</th>
                </tr>
            </thead>

            <tbody>
                {props?.orderData?.lines?.map((line, idx) => (
                    <ProductListRow
                        key={`${line['@id']}_${idx}`}
                        line={line}
                        idx={idx}
                        {...props}
                    />
                ))}
            </tbody>
        </table>
    )
}

export default ProductList
